import {Box, Text, Title} from '@mantine/core';
import {parseCookies} from 'nookies';
import {IoMdVideocam} from 'react-icons/io';
import {IoAlertCircle, IoPlayCircleOutline} from 'react-icons/io5';
import {MdOutlineSlideshow} from 'react-icons/md';
import type {GetWebSeminarsEventsResponse} from '../../../core/repositories/webSeminarsRepository';
import {validateCookie} from '../../../core/usecases/auth/checkOauthTokenExistence';
import {CommonLink} from '../../../shared/components/CommonLink';
import {NoLoginListBox} from './NoLoginListBox';

type Props = {
  webSeminarsEvents?: GetWebSeminarsEventsResponse;
  isStudentVerificationRequired?: boolean;
};

export const WebSeminarsContainer: React.FC<Props> = ({
  webSeminarsEvents,
  isStudentVerificationRequired = false,
}) => {
  const cookies = parseCookies();
  const {isValid} = validateCookie(cookies);

  // 大学認証未完了ユーザーは未ログイン相当の表示にする
  const isViewable = isValid && !isStudentVerificationRequired;

  return isViewable ? (
    <Box className="flex flex-wrap justify-between pc:max-w-[70%] max-w-[95%]">
      {webSeminarsEvents?.map((seminar, index) => (
        <Box
          key={index}
          className="border border-line-1 bg-white pc:w-[calc(33.333%-4px)] mx-6 my-4"
        >
          <Box className="relative w-full h-56 bg-background-1">
            <img
              src={`https://img.youtube.com/vi/${seminar.youTubeVideoID}/maxresdefault.jpg`}
              className="w-full h-auto object-cover"
              alt={seminar.title}
            />
            <Box className="absolute top-0 left-0 w-full h-full bg-overlay-1" />
            <ul className="absolute top-0 left-0">
              {seminar.isOriginal && (
                <li className="bg-notification-1 text-white px-8 py-auto text-sm leading-5 my-4">
                  <IoAlertCircle
                    className="inline-block text-white"
                    size={20}
                  />
                  独占映像
                </li>
              )}
              {seminar.isFreeListing && (
                <li className="bg-white text-notification-1 px-8 py-auto text-sm leading-5 my-4">
                  <IoPlayCircleOutline
                    className="inline-block text-notification-1"
                    size={20}
                  />
                  YouTube
                </li>
              )}
              {seminar.isPrMovie ? (
                <li className="bg-white text-primary-1 px-8 py-auto text-sm leading-5 my-4">
                  <IoMdVideocam
                    className="inline-block text-primary-1"
                    size={20}
                  />
                  企業PV
                </li>
              ) : (
                <li className="bg-white text-primary-1 px-8 py-auto text-sm leading-5 my-4">
                  <MdOutlineSlideshow
                    className="inline-block text-primary-1"
                    size={20}
                  />
                  プレゼン
                </li>
              )}
            </ul>
            <Box className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[180px] h-[48px]">
              <CommonLink
                className="flex items-center justify-center text-xl text-link text-center border-solid border-link border rounded bg-white h-full pc:opacity-90"
                href={`/web_seminars/view/${seminar.webSeminarID}`}
              >
                説明を聞く
              </CommonLink>
            </Box>
          </Box>
          <Box className="p-16">
            <Title
              order={2}
              className="text-lg text-black-default mb-[5px] overflow-hidden line-clamp-2"
            >
              {seminar.title}
            </Title>
            <Text className="text-sm text-black-2 mb-[15px]">
              {seminar.companyInfo.companyName}
            </Text>
            <Text className="text-base text-black-3 overflow-hidden line-clamp-2">
              {seminar.description}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  ) : (
    <NoLoginListBox
      isStudentVerificationRequired={isStudentVerificationRequired}
    />
  );
};
